<template>
  <div id='app'>
    <Collage v-if="currentPage == 'welcome'"></Collage>
    <div id='app-content' class=''>
      <top-menu v-show="true"></top-menu>
      <div id='pager-view' :style="{position: 'relative', height: pageHeight}" v-if="location">
        <div class='scroller'>
          <Page v-if="true" name='welcome' :height="pageHeight"><Welcome @show-page="showPage" :location="location"></Welcome></Page>

          <Page v-if="true" name='food' :height="pageHeight">
            <Food 
              @show-page="showPage" 
              title="What food do you like to eat in India?"
              placeholder-text="Start typing"
              :location="location"
              :poll="location.food"
              next-page="place"
              previous-page="welcome"
              poll-type="food"
              next-hint="Thanks! Next, choose 3 places"
              />
          </Page>

          <Page v-if="true" name='place' :height="pageHeight">
            <Food 
              @show-page="showPage" 
              title="What places would you visit in India?"
              :location="location"
              :poll="location.place"
              placeholder-text="Start typing"
              next-page="results"
              previous-page="food"
              poll-type="place"
              next-hint="And you are done! Let's see the results!"
              />
          </Page>
          <Page name='results' :height="pageHeight">
            <Results
              ref="results"
              :poll-food="location.food"
              :poll-place="location.place"
              :height="pageHeight"
              @show-page="showPage" />
          </Page>
 
          <Page name='next-location' :height="pageHeight">
            <NextLocation :location="location" @show-page="showPage" />
          </Page>

          <Page name='subscribe' :height="pageHeight">
            <Subscribe @show-page="showPage" :location="location" />
          </Page>

          <Page name='blog' :height="pageHeight">
            <Blog @show-page="showPage" />
          </Page>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Page from "./components/widgets/Page";
import TopMenu from "./components/widgets/TopMenu.vue";
import Welcome from "./components/sections/Welcome";
import Food from "./components/sections/Food";
import Results from "./components/sections/Results";
import Collage from "./components/widgets/Collage";
import NextLocation from "./components/sections/NextLocation";
import Subscribe from "./components/sections/Subscribe"
import Blog from "./components/sections/Blog"

import jQuery from 'jquery'
import http from './lib/http.ts';
import { constants } from 'crypto';

export default {
  name: 'app',
  
  components: {
    'top-menu': TopMenu,
    Collage,
    Welcome,
    Food,
    Results,
    Page,
    NextLocation,
    Subscribe,
    Blog
  },

  data() {
    return {
      showFooter: false,
      pageHeight: "0px",
      currentPage: 'welcome',
      location: null
    }
  },

  mounted(){
    let $ = jQuery;
    this.pageHeight = ($(window).height() - $("#top-menu").height() - 1) + "px";

    http().get("/locations").then(r => {
      console.log(r);
      this.location = r.data.location
      this.$nextTick(_ => this.showPage('welcome'));
    });

    this.$ga.page("/");
  },

  methods: {
    showPage(name) {
      let $ = jQuery;
      let top = Math.floor($("[page-name=" + name + "]").position().top) + 1;
      $(".scroller").css('margin-top', -top);
      this.currentPage = name;

      if (name == 'results')
        this.$refs.results.fetch();

      this.$ga.page(`/#page=${name}`);
    }
  }


}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Raleway:400,500,700,900&display=swap');
@import "./assets/style.scss";

HTML, BODY {height: 100%; margin: 0;}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  color: #2c3e50;
  height: 100%;
  
  #app-content {
    position: relative;
    height: 100%;
    z-index: 1;
    overflow: auto;
  }

  #pager-view {
    overflow: hidden;
    .scroller {position: relative; transition: margin-top 0.3s ease-in;}
  }

  h1, h2, h3, h4, h5 {
    margin-top: 0;
    font-weight: 700;
  }

  h3, h5 {
    svg {margin-right: 10px; height: 18px; margin-bottom: 5px; cursor: pointer;}
  }
  h5 svg {margin-bottom: 0px}

  A {color: #333; text-decoration: underline}

  .page H3 {letter-spacing: -1px}
  .page H1 {font-size: 80px; letter-spacing: -3px}
  .page H2 {font-size: 58px; letter-spacing: -1px}

  .navbar-light span.navbar-toggler-icon {background-image: url("/icons/menu.png")}

  @media (max-width: 767.98px) { 
    .page {
      h2 {font-size: 32px}
      h3 {font-size: 24px}
    }
  }

}

</style>
